import { isModuleEnabled } from '@dosfilos/domain';
import { useTenantConfig } from '../../../hooks/use-tenant-config';

/** ¿El seminario usa el aula virtual? `settled` = ya se sabe: hasta entonces la
 *  pantalla espera, para no mostrar los bloques del aula y después esconderlos. */
export function useClassroomOn(): { on: boolean; settled: boolean } {
  const cfg = useTenantConfig();
  return { on: isModuleEnabled(cfg.modules, 'classroom'), settled: cfg.settled };
}
